export default "__VITE_ASSET__31b6dfcd__"